const remoteApiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL || "";
const localProxyBaseUrl = "/api/proxy";

export function getApiBaseUrl() {
  // Always go through our own same-origin Next.js rewrite (/api/proxy) in
  // the browser instead of calling remoteApiBaseUrl directly. The API's
  // CORS allowlist is a fixed set of known origins — relying on the current
  // deployment's exact origin always being on that list is fragile (it
  // silently breaks on staging/preview/custom domains, as happened with the
  // sibling manage-API base in drop.service.ts). Routing through our own
  // server sidesteps CORS entirely: the browser only ever talks to our own
  // origin, and the Next.js server's cross-origin fetch isn't subject to it.
  if (typeof window !== "undefined" && /^https?:\/\//i.test(remoteApiBaseUrl)) {
    return localProxyBaseUrl;
  }

  return remoteApiBaseUrl;
}
